import React, {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import BaseLayout from '../../layout/BaseLayout';
import Homepage from './Homepage';
import OfflineModal from '../../../components/presentationView/parts/components/OfflineModal';
import {usePresentationParams} from '../../../hooks/usePresentationParams';

function PlayerPage(): JSX.Element {
    const navigate = useNavigate();
    const location = useLocation();

    const {presentationId, roomId} = usePresentationParams();

    useEffect(() => {
        if (roomId) {
            navigate(`/room${location.search}`);
        } else if (presentationId) {
            navigate(`/presentation${location.search}`);
        }
    }, [roomId, presentationId, navigate, location.search]);

    return (
        <BaseLayout>
            <>
                <div className="p-player">
                    <Homepage />
                </div>

                <OfflineModal />
            </>
        </BaseLayout>
    );
}

export default PlayerPage;
